import { postFeeLookup as postBillPayFeeLookup, getFieldsForProductRequest as getBillPayFieldsForProductRequest } from "../services/billpay.service";

export type BillPayFeeLookupPayload = {
  agentID: string | null;
  unitProfileID: string | null;
  productType: 'BP';
  productVariant: 'EP';
  AmountItem: string | number | null;
  amountExcludingFee: string | number | null;
  destinationCountry: 'USA';
  receiveCode?: string;
  receiveAgentID?: string;
  receiveCurrency: 'USD';
  allOptions: boolean;
};

export const buildBillPayFeeLookupPayload = (args: {
  agentID: string | null;
  unitProfileID: string | null;
  AmountItem: string | number | null;
  amountExcludingFee: string | number | null;
  receiveCode?: string;
  receiveAgentID?: string;
}): BillPayFeeLookupPayload => {
  return {
    agentID: args.agentID,
    unitProfileID: args.unitProfileID,
    productType: 'BP',
    productVariant: 'EP',
    AmountItem: args.AmountItem,
    amountExcludingFee: args.amountExcludingFee,
    destinationCountry: 'USA',
    receiveCode: args.receiveCode,
    receiveAgentID: args.receiveAgentID,
    receiveCurrency: 'USD',
    allOptions: false,
  };
};

export type BillPayGffpPayload = {
  agentID: string | null;
  unitProfileID: string | null;
  productType: 'BP';
  ProductVariant: 'EP';
  receiveCountry: 'USA';
  ReceiveCurrency: 'USD';
  thirdPartyType: 'NONE';
  receiveAgentID?: string;
  BillerAccountNumber?: string | null;
  cardSwiped: 'false';
  amount: string | number | null;
  CustomerId?: string | number | null;
};

export const buildBillPayGffpPayload = (args: {
  agentID: string | null;
  unitProfileID: string | null;
  receiveAgentID?: string;
  billerAccountNumber?: string | null;
  amount: string | number | null;
  customerId?: string | number | null;
}): BillPayGffpPayload => {
  return {
    agentID: args.agentID,
    unitProfileID: args.unitProfileID,
    productType: 'BP',
    ProductVariant: 'EP',
    receiveCountry: 'USA',
    ReceiveCurrency: 'USD',
    thirdPartyType: 'NONE',
    receiveAgentID: args.receiveAgentID,
    BillerAccountNumber: args.billerAccountNumber,
    cardSwiped: 'false',
    amount: args.amount,
    CustomerId: args.customerId,
  };
};

export function extractBillPayFeeInfo(raw: any): any | null {
  if (raw == null) return null;
  let parsed = raw;
  if (typeof parsed === "string") {
    try {
      parsed = JSON.parse(parsed);
    } catch {
      return null;
    }
  }
  if (parsed?.data !== undefined) {
    parsed = parsed.data;
  }
  return parsed?.FeeInfos?.[0] ?? parsed?.feeInfos?.[0] ?? null;
}

export function syncBillPaySendOptionFromFeeLookup(
  raw: any,
  setters: {
    setSelectedSendOption?: (opt: any | null) => void;
    setPendingSendOption?: (opt: any | null) => void;
  },
): any | null {
  const feeInfo = extractBillPayFeeInfo(raw);
  if (!feeInfo) return null;
  const updatedOption = { ...feeInfo };
  try {
    setters.setSelectedSendOption?.(updatedOption);
  } catch {}
  try {
    setters.setPendingSendOption?.(updatedOption);
  } catch {}
  return updatedOption;
}

export const callPostBillPayFeeLookup = async (payload: BillPayFeeLookupPayload): Promise<any> => {
  return await postBillPayFeeLookup(payload);
};

export const callGetBillPayFieldsForProduct = async (payload: BillPayGffpPayload): Promise<any> => {
  return await getBillPayFieldsForProductRequest(payload);
};

